<template>
    <modal :is-open="isOpen" :portal-to="portalTo">
        <div class="sm:flex sm:items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10" v-if="$slots.icon">
                <slot name="icon" />
            </div>
            <div class="text-center sm:text-left" :class="{'mt-3 sm:mt-0 sm:ml-4': $slots.icon}">
                <h3 id="modal-headline" class="text-lg leading-6 font-medium text-gray-900" v-if="title">
                    {{ title }}
                </h3>
                <div :class="{'mt-2': title}">
                    <slot />
                </div>
            </div>
        </div>
        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <slot name="button">
                <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm" @click="close">
                    OK
                </button>
            </slot>
        </div>
    </modal>
</template>

<script>
    import Modal from '@/components/modals/Modal.vue';

    export default {
        components: { Modal },
        props: {
            isOpen: {
                type: Boolean,
                default: false,
                required: true,
            },
            title: {
                type: String,
                default: '',
            },
            icon: {
                type: String,
                default: '',
            },
            portalTo: {
                type: String,
                default: 'modal',
            },
        },

        watch: {
            isOpen(newValue) {
                if (newValue) {
                    this.$emit('onOpen');
                } else {
                    this.$emit('onClose');
                }
            },
        },

        methods: {
            close() {
                this.$emit('update:isOpen', false);
            },
        },
    };
</script>
